module.exports = __webpack_public_path__ + "img/samping kiri.ff493c34.jpg";